// timezones.js
export const timezones = [
  { code: 'Africa/Johannesburg', name: 'South Africa Time - Johannesburg' },
  { code: 'America/Anchorage', name: 'Alaska Time - Anchorage' },
  { code: 'America/Chicago', name: 'Central Time - Chicago' },
  { code: 'America/Denver', name: 'Mountain Time - Denver' },
  { code: 'America/Honolulu', name: 'Hawaii-Aleutian Time - Honolulu' },
  { code: 'America/Los_Angeles', name: 'Pacific Time - Los Angeles' },
  { code: 'America/Manaus', name: 'Amazon Time - Manaus' },
  { code: 'America/Mexico_City', name: 'Central Time - Mexico City' },
  { code: 'America/New_York', name: 'Eastern Time - New York' },
  { code: 'America/Phoenix', name: 'Mountain Standard Time - Phoenix' },
  { code: 'America/Sao_Paulo', name: 'Brasilia Time - Sao Paulo' },
  { code: 'America/Tijuana', name: 'Pacific Time - Tijuana' },
  { code: 'Asia/Bangkok', name: 'Indochina Time - Bangkok' },
  { code: 'Asia/Dubai', name: 'Gulf Time - Dubai' },
  { code: 'Asia/Jerusalem', name: 'Israel Time - Jerusalem' },
  { code: 'Asia/Kolkata', name: 'India Standard Time - Kolkata' },
  { code: 'Asia/Manila', name: 'Philippine Time - Manila' },
  { code: 'Asia/Seoul', name: 'Korea Standard Time - Seoul' },
  { code: 'Asia/Shanghai', name: 'China Standard Time - Shanghai' },
  { code: 'Asia/Singapore', name: 'Singapore Time - Singapore' },
  { code: 'Asia/Tokyo', name: 'Japan Time - Tokyo' },
  { code: 'Australia/Brisbane', name: 'Australian Eastern Time - Brisbane' },
  { code: 'Australia/Darwin', name: 'Australian Central Time - Darwin' },
  { code: 'Australia/Perth', name: 'Australian Western Time - Perth' },
  { code: 'Australia/Sydney', name: 'Australian Eastern Time - Sydney' },
  { code: 'Europe/Berlin', name: 'Central European Time - Berlin' },
  { code: 'Europe/Copenhagen', name: 'Central European Time - Copenhagen' },
  { code: 'Europe/Lisbon', name: 'Western European Time - Lisbon' },
  { code: 'Europe/London', name: 'British Time - London' },
  { code: 'Europe/Madrid', name: 'Central European Time - Madrid' },
  { code: 'Europe/Paris', name: 'Central European Time - Paris' },
  { code: 'Europe/Vienna', name: 'Central European Time - Vienna' },
  { code: 'Europe/Zurich', name: 'Central European Time - Zurich' },
  { code: 'Pacific/Auckland', name: 'New Zealand Time - Auckland' },
];